export default function composeClassNames(className) {
  if (!className) {
    return '';
  }

  return Array.isArray(className)
    ? className.filter(element => Boolean(element)).join(' ')
    : className;
}
